"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOrg = createOrg;
exports.deleteOrg = deleteOrg;
exports.getOrgById = getOrgById;
exports.orgCombobox = orgCombobox;
exports.queryOrgPage = queryOrgPage;
exports.updateOrg = updateOrg;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function orgCombobox(query) {
  return (0, _requestAuth.default)({
    url: '/sysOrg/orgCombobox',
    method: 'get',
    params: query
  });
}

// 获取组织列表
function queryOrgPage(query) {
  return (0, _requestAuth.default)({
    url: '/sysOrg/page',
    method: 'get',
    params: query
  });
}

// 创建组织
function createOrg(data) {
  return (0, _requestAuth.default)({
    url: '/sysOrg',
    method: 'post',
    data: data
  });
}
// 更新组织信息
function updateOrg(data) {
  return (0, _requestAuth.default)({
    url: '/sysOrg',
    method: 'put',
    data: data
  });
}
// 删除组织信息
function deleteOrg(id) {
  return (0, _requestAuth.default)({
    url: '/sysOrg/delete',
    method: 'delete',
    params: {
      orgId: id
    }
  });
}
// 通过id查询组织信息
function getOrgById(id) {
  return (0, _requestAuth.default)({
    url: '/sysOrg/' + id,
    method: 'get'
  });
}